module.exports = __webpack_public_path__ + "img/reportsMainLink.14e4f466.png";